import React, { useRef, memo } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import useOutsideClick from 'hooks/useOutsideClick';

const RowActions = ({ isOpen, onClickOpen, onClose, children, position }) => {
  const ref = useRef();

  useOutsideClick(ref, () => {
    if (!isOpen) return;
    if (isOpen) {
      onClose();
    }
  });

  return (
    <div
      data-testid="row-actions"
      className="mx-2 w-auto relative transition-all ease-in-out"
      ref={ref}
    >
      <span
        data-testid="clickable"
        className={`py-0.5 w-7 flex items-center justify-center ml-auto cursor-pointer border rounded ${
          isOpen
            ? 'bg-brand-primary text-white border-brand-primary'
            : 'bg-white text-javelin-gray-light'
        }`}
        onClick={onClickOpen}
      >
        <FontAwesomeIcon
          icon="ellipsis-h"
          className="fill-current self-center text-center flex-shrink-0"
          size="sm"
        />
      </span>
      <div
        className={`${
          isOpen ? 'opacity-100 z-50' : 'hidden opacity-0'
        } w-56 card px-0 py-1 absolute bg-white rounded shadow-md ${
          position === 'top' ? '-bottom-5' : '-top-1'
        } right-6 duration-200 text-left`}
        data-testid="container"
      >
        {children}
      </div>
    </div>
  );
};

RowActions.propTypes = {
  onClickOpen: PropTypes.func,
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
  position: PropTypes.oneOf(['top', 'bottom']),
  childrent: PropTypes.node,
};
RowActions.defaultProps = {
  position: 'bottom',
};

export default memo(RowActions);
